export const heroData = {
  title: 'INFINITE REYN PRODUCTIONS',
  tagline: 'Where Stories Take Form',
  backgroundImage: '/images/hero/main-hero.jpg'
};

export const projects = [
  // Music - REAL RELEASE
  {
    id: 'songs-of-songs',
    title: 'Songs of Songs: A Love Letter to the Divine',
    artist: 'Divine Reyn',
    description: 'A 16-track journey of worship and devotion, blending English and Spanish in an intimate conversation with the divine.',
    fullDescription: 'Songs of Songs: A Love Letter to the Divine is an intimate 16-track album that bridges languages and spirit. Divine Reyn weaves together English and Spanish in a tapestry of devotion, creating a sonic space where the sacred meets the deeply personal. Released August 16, 2025.',
    image: '/images/music/songs-of-songs.webp',
    category: 'music',
    status: 'released',
    releaseDate: 'August 16, 2025',
    landingPage: '/launch/songs-of-songs#listen',
    link: 'https://music.apple.com/us/album/songs-of-songs-a-love-letter-to-the-divine/1834690128',
    youtubeLink: 'https://www.youtube.com/watch?v=E6R62yTvjgE&list=OLAK5uy_mYyk_F5cwWAub_3XS70mYLpoBOy0a5rEc',
    amazonLink: 'https://www.amazon.com/You-Are-Holy/dp/B0FN48BXMD',
    tracks: [
      'Amor Mio',
      'Cancio de Amor',
      'Dijiste No',
      'Eli, Eli (English)',
      'Eli, Eli (Spanish)',
      'Gracias Por Amarme',
      'Love Song',
      'Mi Corazon Clama A Ti',
      'My Heart Cries Out To You',
      'My Beloved',
      'Suelta Y Deja A Dios',
      'Tu Eres Santo',
      'Upside Down',
      'Yo Quiero Amarte',
      'You Are Holy',
      'You Said No'
    ]
  },
  // Books - REAL UPCOMING
  {
    id: 'phantom-claim',
    title: 'The Phantom Claim',
    author: 'Evie Montclaire',
    description: 'He rejected their bond in public. She will make him earn it in private.',
    fullDescription: 'A gripping paranormal romance where destiny meets defiance. Coming April 20, 2026.',
    image: '/images/launcher/phantom-claim-cover.png',
    category: 'books',
    status: 'upcoming',
    releaseDate: 'April 20, 2026',
    landingPage: '/launch/the-phantom-claim',
    amazonUrl: 'https://amzn.to/4sRlWOh',
    authorUrl: 'https://www.amazon.com/stores/Evie-Montclaire/author/B0GVWLQD34'
  },
  // Theatre - Coming Soon
  {
    id: 'theatre-tbd',
    title: 'Something Growing',
    description: 'A theatrical experience in development...',
    fullDescription: 'We have something growing in the theatre space. Stay tuned.',
    image: '/images/theatre/theatre-hero.jpg',
    category: 'theatre',
    status: 'upcoming',
    releaseDate: 'TBA',
    landingPage: '/launch/theatre-announcement'
  }
];

export const socialLinks = [
  { name: 'Twitter', icon: 'twitter', url: '#' },
  { name: 'YouTube', icon: 'youtube', url: '#' },
  { name: 'Instagram', icon: 'instagram', url: '#' },
  { name: 'Facebook', icon: 'facebook', url: '#' }
];

// Blog Posts
export const blogPosts = [
  {
    id: 'welcome-to-infinite-reyn',
    title: 'Welcome to Infinite Reyn Productions',
    author: 'Infinite Reyn Productions',
    date: 'January 15, 2025',
    category: 'updates',
    readTime: '3 min read',
    excerpt: 'The launch of a multi-disciplinary creative house built on a single conviction: that human experience is too vast for any one medium.',
    image: '/images/blog/welcome.jpg',
    content: `
      <p>Some stories are meant to be read in the dark. Some need a room full of people and someone willing to say the true thing out loud. Infinite Reyn Productions exists for all three.</p>
      
      <p>Founded on the principle that the most important stories refuse to stay in one form, we work across Books, Music, and Theatre: three mediums, one source, and the same relentless interrogation of what it means to be alive in a body, in relationship, in a world that doesn't always make room for the whole of you.</p>
      
      <h3>Why Three Verticals?</h3>
      
      <p>Because human experience doesn't fit neatly into categories. A story about connection might need the intimacy of the page, the visceral power of live performance, or the spiritual resonance of song. We don't choose the medium first; we let the story choose how it wants to be told.</p>
      
      <h3>What We're Building</h3>
      
      <p>Under the umbrella of Infinite Reyn Productions, you'll find:</p>
      
      <ul>
        <li><strong>Books</strong>: Evie Montclaire's paranormal romance that carries more truth than it announces</li>
        <li><strong>Music</strong>: Divine Reyn and Wild Reyn's worship that meets the sacred in difficult places</li>
        <li><strong>Theatre</strong>: Productions that ask the questions most rooms are too polite to ask</li>
      </ul>
      
      <p>Each vertical operates with its own voice, its own aesthetic, and its own truth. What connects them is invisible architecture, specifically the expertise in psychology, trauma, and the arts that shapes emotional precision without ever becoming the subject.</p>
      
      <h3>What's Next</h3>
      
      <p>We're currently in production on multiple fronts. "Songs of Songs: A Love Letter to the Divine" is available now. "The Phantom Claim" arrives April 20, 2026. And in theatre, something is growing: something that will change the temperature of the room before the lights even come up.</p>
      
      <p>This is where stories take form. All of them.</p>
    `
  },
  {
    id: 'songs-of-songs-release',
    title: 'Songs of Songs: A Love Letter to the Divine, Out Now',
    author: 'Divine Reyn',
    date: 'August 16, 2025',
    category: 'news',
    readTime: '2 min read',
    excerpt: 'A 16-track journey of worship and devotion, blending English and Spanish in an intimate conversation with the divine.',
    image: '/images/music/songs-of-songs.webp',
    content: `
      <p>"Songs of Songs: A Love Letter to the Divine" is now available on all streaming platforms. This is worship music that meets the sacred in difficult places; it is raw, spiritual, and bilingual.</p>
      
      <p>The album moves between English and Spanish, creating a sonic space where the human and the holy don't flinch from each other. It's an intimate conversation, 16 tracks that bridge languages and spirit.</p>
      
      <h3>The Tracklist</h3>
      
      <p>From "You Said No" to "Amor Mio," each song explores a different facet of devotion: the questioning, the surrender, the gratitude, and the cry for connection. "Eli, Eli" sits at the center, a moment of raw vulnerability that doesn't apologize for its need.</p>
      
      <p>This isn't background music. It's meant to be felt, not just heard.</p>
      
      <h3>Listen Now</h3>
      
      <p>Available on Apple Music, Spotify, and everywhere you stream music. Put on headphones. Find a quiet moment. Let it speak.</p>
    `
  },
  {
    id: 'phantom-claim-announcement',
    title: 'The Phantom Claim, Coming April 2026',
    author: 'Evie Montclaire',
    date: 'December 1, 2025',
    category: 'news',
    readTime: '4 min read',
    excerpt: 'He rejected their bond in public. She will make him earn it in private. The first book in the Fenmor Pack series arrives April 20, 2026.',
    image: '/images/launcher/phantom-claim-cover.png',
    content: `
      <p>Sometimes a bond is a gift. Sometimes it's a weapon. And sometimes, it's both.</p>
      
      <p>"The Phantom Claim" is paranormal romance that refuses to announce itself. Gothic, grounded, and wry, it is the kind of book that reads fast and lands slow.</p>
      
      <h3>The Story</h3>
      
      <p>Vera thought she knew what rejection felt like. She was wrong. When her fated mate publicly denies their bond, she's left with a choice: fade into the background or force him to see her. She chooses the latter.</p>
      
      <p>Aeden made a mistake. He knows it. But pride and pack politics don't leave room for apologies. When Vera turns the tables, making him work for what he threw away, he realizes the bond he rejected might be the only thing that saves him.</p>
      
      <p>This is a story about power: who has it, who takes it, and what happens when two people who refuse to bend finally meet their match.</p>
      
      <h3>The World</h3>
      
      <p>Set in the Fenmor Pack universe, where werewolf politics are messy, bonds are complicated, and no one gets a happy ending without earning it. Think less fated mates and instant devotion, more "I hate that I want you and I'm going to make you regret it."</p>
      
      <h3>Release Details</h3>
      
      <p><strong>Title:</strong> The Phantom Claim<br>
      <strong>Author:</strong> Evie Montclaire<br>
      <strong>Release Date:</strong> April 20, 2026<br>
      <strong>Series:</strong> Fenmor Pack #1<br>
      <strong>Genre:</strong> Paranormal Romance</p>
      
      <p>Pre-orders coming soon. Mark your calendars.</p>
    `
  },
  {
    id: 'writing-across-mediums',
    title: 'Writing Across Mediums: When Stories Demand Different Forms',
    author: 'Infinite Reyn Productions',
    date: 'November 10, 2025',
    category: 'insights',
    readTime: '6 min read',
    excerpt: 'Why some stories need pages, some need stages, and some need to be sung. On the architecture of choosing how a story wants to be told.',
    image: '/images/blog/writing.jpg',
    content: `
      <p>The question I get asked most often: "How do you decide if something becomes a book, a song, or a play?"</p>
      
      <p>The honest answer? I don't decide. The story does.</p>
      
      <h3>The Architecture of Form</h3>
      
      <p>Every story has an inherent architecture, a shape it wants to take, and a medium it demands. Some stories need the intimacy of the page, where a reader can pause, reflect, and return. Some need the immediacy of the stage, where breath and body make meaning. And some need to be sung, where melody carries what words alone cannot.</p>
      
      <p>The mistake is assuming the creator chooses. We don't. We listen.</p>
      
      <h3>Books: The Architecture of Interiority</h3>
      
      <p>Books are for stories that live inside. The kind that need time to unfold, space to breathe, and silence to land. When I'm writing as Evie Montclaire, I'm working with interiority: the private thoughts, the unspoken tensions, and the slow burn of desire and denial.</p>
      
      <p>Paranormal romance is perfect for this. The external conflict (pack politics, fated bonds, rejection) is just the container. The real story is internal: who do you become when the world tells you who you're supposed to want?</p>
      
      <h3>Music: The Architecture of the Sacred</h3>
      
      <p>Music is for what can't be said, only felt. As Divine Reyn and Wild Reyn, I'm working with the space between language and experience. Worship isn't about doctrine; it's about the moment when words fail and melody takes over.</p>
      
      <p>The bilingual aspect (English and Spanish) isn't a gimmick. It's necessity. Some prayers only work in the language your grandmother spoke. Some emotions only have names in English. The divine doesn't care about linguistic borders.</p>
      
      <h3>Theatre: The Architecture of Presence</h3>
      
      <p>Theatre is for stories that need witnesses. The ones that only work when there's a room full of people holding their breath together. Theatre isn't about perfection; it is about presence, risk, and the possibility that something could go wrong, which is exactly the point.</p>
      
      <p>The projects growing in our theatre vertical are the ones that can't exist anywhere else. They need bodies, breath, the tension of liveness. They need the question hanging in the air: "Did that just happen?"</p>
      
      <h3>The Connective Tissue</h3>
      
      <p>What connects these three verticals isn't subject matter. It's precision. Every project under Infinite Reyn Productions, whether it's Evie's books, Divine Reyn's music, or our theatre work, operates with the same invisible architecture: clinical psychology, trauma work, and a refusal to flinch from the complicated parts.</p>
      
      <p>That expertise doesn't announce itself. It shapes the work without becoming the subject of it.</p>
      
      <h3>For Other Creators</h3>
      
      <p>If you're working across mediums, my advice: Stop deciding and start listening. The story will tell you how it wants to be told. Your job is to be fluent enough in multiple forms to follow where it leads.</p>
      
      <p>Some stories are meant to be read in the dark. Some need a room full of people and someone willing to say the true thing out loud. And some need to be sung until the words don't matter anymore.</p>
      
      <p>All of them matter. All of them have a place.</p>
    `
  }
];
